import { httpClient } from "./httpClient";

const calculateOT = (date, start, end, value) => {
    return httpClient.post(`/calculate/ot?date=`+date+`&start=`+start+`&end=`+end, value);
};

export default {
    calculateOT
};